import {
  changePassword,
  getUsers,
  insertUser,
  updateUser,
  BaseApiRequest,
  getLoggedUserPermissions,
  getUser,
  PermissionsGroups,
} from "@robe/core-api";
import { User } from "@robe/core-types";
import { XcoreCore } from "XcoreCore";

export class XcoreUser {
  private core: XcoreCore;

  public constructor(core: XcoreCore) {
    this.core = core;
  }

  public getCurrentUser(): BaseApiRequest<User> {
    return getUser(this.core);
  }

  public getUserById(id: number): BaseApiRequest<User> {
    return getUser(this.core, id);
  }

  public list(): BaseApiRequest<User[]> {
    return getUsers(this.core);
  }

  public insert(user: Omit<User, "id">): BaseApiRequest<User> {
    return insertUser(user, this.core);
  }

  public update(user: User): BaseApiRequest<User> {
    return updateUser(user, this.core);
  }

  public changePassword(oldPassword: string, newPassword: string): BaseApiRequest<void> {
    return changePassword(oldPassword, newPassword, this.core);
  }

  public getPermissions(): BaseApiRequest<PermissionsGroups> {
    return getLoggedUserPermissions(this.core);
  }
}
